"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animate = animate;
const helpers_1 = require("../../shared/helpers");
function animate(animation, itemToAnimate) {
    if (animation == 'pulse') {
        const elementToAnimate = document.getElementById(itemToAnimate);
        return (0, helpers_1.triggerAnimation)(elementToAnimate, 'pulse 2s 0s');
    }
    else if (animation == 'drag') {
        const elementToAnimate = document.getElementById('stim-image');
        const dragTargetElement = document.getElementById(itemToAnimate);
        const blackOutImage = itemToAnimate === 'target';
        return (0, helpers_1.displaceAnimation)(dragTargetElement, elementToAnimate, 'destination', 0, 0, false, blackOutImage);
    }
}
